/**
 * Add and remove a CSS class to the observable element.
 *
 * @param {IntersectionObserverEntry} observable
 * @param {HTMLElement} stickyElement
 * @param {string} toggleClass
 */
function intersectionObserverCallback(observable, stickyElement, toggleClass) {
  const stickyElementVisibleClass = `${toggleClass}--visible`;
  stickyElement.classList.toggle(
    stickyElementVisibleClass,
    !observable.isIntersecting,
  );
}

/**
 * Add a CSS class to the footer with a margin, so it's not hidden by the sticky element
 */
function setFooterMargin() {
  const footerElement = document.querySelector('.footer-bottom__wrapper');

  if (footerElement) {
    footerElement.classList.add('footer-bottom__wrapper--margin-bottom');
  }
}

/**
 * Creates an observer which will trigger a callback each time an observable element is visible or not.
 *
 * @param {string} stickySelector
 * @param {string} observableSelector
 * @param {string} toggleClass
 */
export const stickyCta = (stickySelector, observableSelector, toggleClass) => {
  const stickyElement = document.querySelector(stickySelector);

  if (!stickyElement) {
    return;
  }

  const intersectionCallback = (entries) => {
    entries.forEach((entry) => {
      intersectionObserverCallback(entry, stickyElement, toggleClass);
    });
  };

  new IntersectionObserver(intersectionCallback, {
    threshold: 0.1,
  }).observe(document.querySelector(observableSelector));

  // Sticky CTA at bottom that hides the footer
  if ([ '.home-sticky', '.bigteam-fixed-anchor' ].includes(stickySelector)) {
    setFooterMargin();
  }
};
